import { GATrackingEvent, GATrackingEventPayload } from '~shared/modules/ga-tracking/models';
import { GATrackingEventType } from '~shared/modules/ga-tracking/constants';

export class GATrackingOptimizeEvent implements GATrackingEvent {

  constructor(
    private event: string,
    private category: string) { }

  getEventType(): GATrackingEventType {
    return GATrackingEventType.Optimize;
  }

  getPayload(): GATrackingEventPayload {
    return {
      event: this.event,
      category: this.category
    };
  }
}
